"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function () {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  __setModuleDefault(result, mod);
  return result;
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.EntityAuthor = exports.EntityAuthorDefaultProps = void 0;
var react_1 = __importStar(require("react"));
var styled_components_1 = __importStar(require("styled-components"));
var theme_1 = require("@shapeable/theme");
var use_lang_1 = require("../../hooks/use-lang");
var format_date_string_1 = require("../../utils/format-date-string");
var person_photo_1 = require("./person-photo");
exports.EntityAuthorDefaultProps = {
  type: 'creator'
};
// -------- Styles -------->
var ContainerStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    display: flex;\n    align-items: center;\n    font-size: ", ";\n  "], ["\n    display: flex;\n    align-items: center;\n    font-size: ", ";\n  "])), theme_1.theme.FONT_SIZE(11)),
  desktop: (0, styled_components_1.css)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    font-size: ", ";\n  "], ["\n    font-size: ", ";\n  "])), theme_1.theme.FONT_SIZE(13))
});
var PhotoStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    margin-right: ", ";\n  "], ["\n    margin-right: ", ";\n  "])), theme_1.theme.UNIT(2))
});
var InfoStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    line-height: 1.4em;\n  "], ["\n    line-height: 1.4em;\n  "])))
});
var NameStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n    color: ", ";\n    font-size: 1em;\n    margin: 0;\n  "], ["\n    color: ", ";\n    font-size: 1em;\n    margin: 0;\n  "])), theme_1.theme.COLOR('text'))
});
var ActionAndDateStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n    color: ", ";\n    font-size: 1em;\n  "], ["\n    color: ", ";\n    font-size: 1em;\n  "])), theme_1.theme.COLOR('text-mid'))
});
var ActionStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n    display: inline-block;\n    margin-right: ", ";\n    text-transform: uppercase;\n  "], ["\n    display: inline-block;\n    margin-right: ", ";\n    text-transform: uppercase;\n  "])), theme_1.theme.UNIT(1))
});
var DateStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n  "], ["\n  "])))
});
// -------- Components -------->
var My = {
  Container: styled_components_1.default.div(templateObject_9 || (templateObject_9 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  Photo: (0, styled_components_1.default)(person_photo_1.PersonPhoto)(templateObject_10 || (templateObject_10 = __makeTemplateObject(["", ""], ["", ""])), PhotoStyles),
  Info: styled_components_1.default.div(templateObject_11 || (templateObject_11 = __makeTemplateObject(["", ""], ["", ""])), InfoStyles),
  Name: styled_components_1.default.h3(templateObject_12 || (templateObject_12 = __makeTemplateObject(["", ""], ["", ""])), NameStyles),
  ActionAndDate: styled_components_1.default.div(templateObject_13 || (templateObject_13 = __makeTemplateObject(["", ""], ["", ""])), ActionAndDateStyles),
  Action: styled_components_1.default.span(templateObject_14 || (templateObject_14 = __makeTemplateObject(["", ""], ["", ""])), ActionStyles),
  Date: styled_components_1.default.time(templateObject_15 || (templateObject_15 = __makeTemplateObject(["", ""], ["", ""])), DateStyles)
};
var EntityAuthor = function (props) {
  var className = props.className,
    entity = props.entity,
    type = props.type;
  var createdBy = entity.createdBy,
    updatedBy = entity.updatedBy,
    created = entity.created,
    updated = entity.updated;
  var t = (0, use_lang_1.useLang)();
  var person = type === 'creator' ? createdBy : updatedBy;
  var action = (0, react_1.useMemo)(function () {
    return t(type === 'creator' ? 'created' : 'updated');
  }, []);
  var date = type === 'creator' ? created : updated;
  var formattedDate = (0, format_date_string_1.formatDateString)(date, 'DD MMM YY');
  return react_1.default.createElement(My.Container, {
    className: className
  }, react_1.default.createElement(My.Photo, {
    size: 40,
    entity: person
  }), react_1.default.createElement(My.Info, null, react_1.default.createElement(My.Name, null, person.name), react_1.default.createElement(My.ActionAndDate, null, react_1.default.createElement(My.Action, null, action, ":"), react_1.default.createElement(My.Date, {
    datetime: date
  }, formattedDate))));
};
exports.EntityAuthor = EntityAuthor;
exports.EntityAuthor.defaultProps = exports.EntityAuthorDefaultProps;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11, templateObject_12, templateObject_13, templateObject_14, templateObject_15;